import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApiModule } from '../api.module';
import { ApiSmsHelperPipe, ApiSmsHelperUnpurePipe } from './sms-helper.pipe';

@NgModule({
  declarations: [ApiSmsHelperPipe, ApiSmsHelperUnpurePipe],
  imports: [CommonModule, ApiModule],
  exports: [ApiSmsHelperPipe, ApiSmsHelperUnpurePipe],
  providers: [ApiSmsHelperPipe],
})
export class ApiSmsModule {}
